<template>
  <div class="mainNew">
    <div class="topTitle">
      <span style="font-family:'PingFangBold';color:#333333;font-size: 16px;">财务中心</span>
      / 课消记录
    </div>
    <div class="input-student-management">
      <section>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="学员名称">
            <div style="overflow: hidden;">
              <autocomplete1 @getUserId="getUserId"></autocomplete1>
            </div>
          </el-form-item>

          <el-form-item label="班级名称">
            <div style="overflow: hidden;">
              <classArr @getclassId="getclassId"></classArr>
            </div>
          </el-form-item>
          <el-form-item label="上课老师">
            <el-select size="small" @change="search" v-model="formInline.lecturer_id" placeholder="请选择" clearable>
              <el-option v-for="item in options3" :key="item.id" :label="item.realname + ' ' + '(' + item.name + ')'" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程商品">
            <goods @getgoodId="getgoodId"></goods>
          </el-form-item>
          <el-form-item label="课消来源">
            <el-select size="small" @change="search" multiple collapse-tags v-model="formInline.cost_type_arr" placeholder="请选择" clearable>
              <el-option v-for="item in options4" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上课时间">
            <el-date-picker size="small" @change="search" :picker-options="pickerOptions" style="width: 200px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="formInline.creatTime1" type="datetimerange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" placement="bottom-start">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="点名时间">
            <el-date-picker size="small" @change="search" :picker-options="pickerOptions" style="width: 200px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="formInline.creatTime" type="datetimerange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" placement="bottom-start">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="课消时间">
            <el-date-picker size="small" @change="search" :picker-options="pickerOptions" style="width: 200px;" value-format="yyyy-MM-dd HH:mm:ss" v-model="formInline.creatTime2" type="datetimerange" align="right" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" placement="bottom-start">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="small" @click="search" v-if="$attrs.methodAuthTabView('查询')">查询</el-button>
            <el-button size="small" type="primary" @click="handleExport" v-if="$attrs.methodAuthTabView('导出excel')">导出excel</el-button>
          </el-form-item>
        </el-form>
        <div class="sumBg">
          <span style="font-weight: bold;">课消金额总计(元): </span>
          <span style="font-weight: bold;margin-left:10px;color:#ee7d37;">{{
            sumData.total_cost_money
          }}</span>
          <span style="margin-left: 10px;font-weight: bold;">
            消耗课时总计(课时):</span>
          <span style="font-weight: bold;margin-left:10px;color:#ee7d37;">{{
            sumData.total_lesson_hour_num
          }}</span>
        </div>
        <div>
          <el-table id="outLTable" ref="multipleTable" :data="tableData" style="width: 100%; margin-top: 0px;" :header-cell-style="{
              background: '#f5f7fa',
              color: '#606266',
              'font-size': '14px',
            }" stripe>
            <el-table-column prop="stu_name" label="学员姓名" width="150">
            </el-table-column>
            <el-table-column prop="className" label="所在班级" width="200"></el-table-column>
            <el-table-column prop="tchPlanLessonTitle" label="课程名称" width="150">
            </el-table-column>
            <el-table-column prop="" label="上课时间" show-overflow-tooltip width="230">
              <template slot-scope="scope">
                <span v-if="scope.row.tchPlanStartClassDate">
                  {{
                    scope.row.tchPlanStartClassDate
                  }}
                  <!-- {{ scope.row.tchPlanEndClassDate.slice(10, 16) }} -->
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column prop="xmGoodsName" label="课程商品" width="150">
            </el-table-column>
            <el-table-column prop="tchPlanLecturerName" label="上课老师">
            </el-table-column>
            <el-table-column label="课消来源" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.cost_type == 1">点名</span>
                <span v-if="scope.row.cost_type == 2">修改点名记录</span>
                <span v-if="scope.row.cost_type == 3">课时清零</span>
                <span v-if="scope.row.cost_type == 4">撤销点名记录</span>
                <span v-if="scope.row.cost_type == 5">补扣超上课时</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="点名时间" show-overflow-tooltip width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.tchPlanSignDate">
                  {{
                    scope.row.tchPlanSignDate.slice(
                      0,
                      scope.row.tchPlanSignDate.length - 3
                    )
                  }}
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column prop="lesson_hour_num" label="课消额度" width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.lesson_hour_num < 0">退还
                  {{ scope.row.lesson_hour_num.toString().slice(1) }} 课时</span>
                <span v-else>消耗 {{ scope.row.lesson_hour_num }} 课时</span>

                <el-button type="text" @click="details(scope.row)" size="mini">（详情）</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="cost_money" label="课消金额（元）" width="200">
              <template slot-scope="scope">
                <span>￥{{ scope.row.cost_money.toFixed(2) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="created_time" label="课消时间" width="180">
            </el-table-column>
            <el-table-column prop="deal_user_realname" label="操作人">
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-style">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size" layout="total,sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
      </section>
    </div>
    <el-dialog title="查看详情" :visible.sync="dialogVisible" width="50%">
      <div>
        课消来源：<span v-if="xmLesonHourRecordInfo.cost_type === 1">点名</span>
        <span v-if="xmLesonHourRecordInfo.cost_type == 2">修改点名记录</span>
        <span v-if="xmLesonHourRecordInfo.cost_type == 3">课时清零</span>
        <span v-if="xmLesonHourRecordInfo.cost_type == 4">撤销点名记录</span>
        <span v-if="xmLesonHourRecordInfo.cost_type == 5">补扣超上课时</span>
      </div>
      <div style="border:1px solid #E8E8E8;padding:15px;margin-top:15px">
        <ul style="overflow:hidden">
          <li class="liStyle">
            <span>学员姓名：{{ xmLesonHourRecordInfo.stu_name }}</span>
          </li>
          <li class="liStyle">
            <span>上课班级：{{ xmLesonHourRecordInfo.className }}</span>
          </li>
          <li class="liStyle">
            <span>课程名称：{{ xmLesonHourRecordInfo.tchPlanLessonTitle }}</span>
          </li>
          <li class="liStyle">
            <span>上课时间：{{ xmLesonHourRecordInfo.tchPlanStartClassDate }}</span>
          </li>
          <li class="liStyle">
            <span>到课状态：<span v-if="xmLesonHourRecordInfo.stu_sign_state == 1">已出勤</span>
              <span v-if="xmLesonHourRecordInfo.stu_sign_state == 2">缺勤</span>
            </span>
          </li>
          <li class="liStyle">
            <span>上课老师：{{ xmLesonHourRecordInfo.tchPlanLecturerName }}</span>
          </li>
          <li class="liStyle">
            <span>课时变更：
              <span v-if="xmLesonHourRecordInfo.lesson_hour_num < 0">退还
                {{ xmLesonHourRecordInfo.lesson_hour_num.toString().slice(1) }}
                课时</span>
              <span v-else>消耗 {{ xmLesonHourRecordInfo.lesson_hour_num }} 课时</span></span>
          </li>
          <li class="liStyle">
            <span>点名老师：{{ xmLesonHourRecordInfo.deal_user_realname }}</span>
          </li>
          <li class="liStyle">
            <span>课消时间：{{ xmLesonHourRecordInfo.created_time }}</span>
          </li>
          <li class="liStyle">
            <span>点名时间：{{ xmLesonHourRecordInfo.stu_sign_date }}</span>
          </li>
        </ul>
      </div>
      <div style="margin-top:15px">
        消耗订单
      </div>
      <div>
        <el-table size="mini" ref="multipleTable" :data="tableData1" style="width: 100%; margin-top: 20px;" :header-cell-style="{ background: '#f5f7fa', color: '#909399' }" stripe>
          <el-table-column prop="xmOrderGoodsInfo.xmOrderCode" label="订单号" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="xmOrderGoodsInfo.goods_name" label="购买课程" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="" label="单价" show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                (
                  scope.row.xmOrderGoodsInfo.total_amount /
                  scope.row.xmOrderGoodsInfo.buy_num
                ).toFixed(2)
              }}
            </template>
          </el-table-column>
          <el-table-column prop="cost_buy_num" label="消耗购买数量">
          </el-table-column>
          <el-table-column prop="cost_give_num" label="消耗赠送数量">
          </el-table-column>
          <el-table-column prop="cost_money" label="课消金额（元）"></el-table-column>
        </el-table>
      </div>
      <span slot=" footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  // getXmLessonHourRecord,
  getCampusUserList,
  getXmLessonHourRecordDetail,
} from '@/api/educational.js'
import {
  api_lessonHourRecordSelectLessonCost
} from '@/api/javaApi'
import autocomplete1 from '@/components/autocomplete1'
import classArr from '@/components/classArr'
import goods from '@/components/goods'
// import XLSX from "xlsx";
import moment from 'moment'
import { downLoadFileExcelHandle } from '@/utils/exportExcel'

export default {
  components: {
    autocomplete1,
    classArr,
    goods,
  },
  name: 'input-student-management',
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const start = moment().format('YYYY-MM-DD 00:00:00')
              const end = moment().format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本周',
            onClick(picker) {
              const start = moment(
                moment()
                  .week(moment().week())
                  .startOf('week')
                  .add(1, 'days')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .week(moment().week())
                  .endOf('week')
                  .add(1, 'days')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              console.log(start, 1234165)
              console.log(end, 1234165)

              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上周',
            onClick(picker) {
              const start = moment(
                moment()
                  .week(moment().week() - 1)
                  .startOf('week')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .week(moment().week() - 1)
                  .endOf('week')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本月',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .format('YYYY-MM-DD 00:00:00')
              const end = moment()
                .endOf('month')
                .format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上月',
            onClick(picker) {
              const start = moment()
                .subtract(1, 'month')
                .startOf('month')
                .format('YYYY-MM-DD 00:00:00')
              const end = moment()
                .subtract(1, 'month')
                .endOf('month')
                .format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本季度',
            onClick(picker) {
              const start = moment(
                moment()
                  .quarter(moment().quarter())
                  .startOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .quarter(moment().quarter())
                  .endOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上季度',
            onClick(picker) {
              const start = moment(
                moment()
                  .quarter(moment().quarter() - 1)
                  .startOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .quarter(moment().quarter() - 1)
                  .endOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本年',
            onClick(picker) {
              const start = moment(
                moment()
                  .year(moment().year())
                  .startOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .year(moment().year())
                  .endOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上年',
            onClick(picker) {
              const start = moment(
                moment()
                  .year(moment().year() - 1)
                  .startOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .year(moment().year() - 1)
                  .endOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      sumData: {},
      xmLesonHourRecordInfo: {},
      dialogVisible: false,
      student_user_id: '',
      tableData: [],
      tableData1: [],
      page_no: 1,
      page_size: 10,
      total: 1,
      formInline: {
        cost_type_arr: [],
        creatTime: [],
        creatTime1: [],
        creatTime2: [],
      },
      options3: [],
      options2: [],
      options5: [], //班级
      options4: [
        {
          id: '1',
          title: '点名',
        },
        {
          id: '2',
          title: '修改点名记录',
        },
        {
          id: '3',
          title: '课时清零',
        },
        {
          id: '4',
          title: '撤销点名记录',
        },
        {
          id: '5',
          title: '补扣超上课时',
        },
      ],
    }
  },
  mounted() {
    this.getCampusUserList()
    this.getXmLessonHourRecord()
    // this.getXmGoodsListForgetXmLessonHourRecor()
  },

  methods: {
    handleExport() {
      const params = {
        eduCampusId: this.$store.state.user.selected_schools[0], // 校区Id
        stuId: this.student_user_id, // 学员ID
        classId: this.formInline.curriculum_class_id, // 班级ID
        goodsId: this.formInline.xm_goods_id, // 课程商品ID
        userId: this.formInline.lecturer_id, // 上课老师ID
        startCreateDate:
          this.formInline.creatTime2 === null
            ? ''
            : this.formInline.creatTime2[0], // 创建时间-开始
        endCreateDate:
          this.formInline.creatTime2 === null
            ? ''
            : this.formInline.creatTime2[1], // 创建时间-结束
        startSignDate:
          this.formInline.creatTime === null
            ? ''
            : this.formInline.creatTime[0], // 点名时间-开始
        endSignDate:
          this.formInline.creatTime === null
            ? ''
            : this.formInline.creatTime[1], // 点名时间 - 结束
        startClassDate:
          this.formInline.creatTime1 === null
            ? ''
            : this.formInline.creatTime1[0], // 上课时间- 开始
        endClassDate:
          this.formInline.creatTime1 === null
            ? ''
            : this.formInline.creatTime1[1], // 上课时间- 结束
        costTypeList: this.formInline.cost_type_arr.length > 0 ? this.formInline.cost_type_arr : null, //课消来源（1点名，2修改点名记录，3课时清零，4撤销点名记录，5补扣超上课时）
      }
      downLoadFileExcelHandle('/java-api/school/lessonHourRecord/exportLessonCost', params, '课消记录')

    },
    // exportExcel() {

    //   var xlsxParam = { raw: true };
    //   var fix = document.querySelector('#outLTable .el-table__fixed');
    //   var fix1 = document.querySelector('#zf');
    //   console.log(fix1, 2254)
    //   console.log(fix, 2254)
    //   var wb;

    //   if (fix) {

    //     wb = XLSX.utils.table_to_book(document.querySelector('#outLTable').removeChild(fix), xlsxParam);
    //     document.querySelector('#outLTable').appendChild(fix);
    //   } else {
    //     wb = XLSX.utils.table_to_book(document.querySelector('#outLTable'));
    //   }
    //   /* get binary string as output */
    //   var wbout = XLSX.write(wb, {
    //     bookType: 'xlsx',
    //     bookSST: true,
    //     type: 'array'
    //   });
    //   try {
    //     FileSaver.saveAs(
    //       new Blob([wbout], {
    //         type: 'application/octet-stream'
    //       }),
    //       "课消记录.xlsx"

    //     );
    //   } catch (e) {
    //     if (typeof console !== 'undefined') console.log(e, wbout);
    //   }
    //   return wbout;

    // },
    // getXmGoodsListForgetXmLessonHourRecor() {
    //     getXmGoodsListForgetXmLessonHourRecor({
    //         campusIds: JSON.stringify(this.$store.state.user.selected_schools),
    //         page_no: 1,
    //         page_size: 500,
    //     }).then((res) => {
    //         console.log(res, 7845645);
    //     })
    // },
    getgoodId(val) {
      this.formInline.xm_goods_id = val
      this.search()
    },
    getclassId(val) {
      this.formInline.curriculum_class_id = val
      this.search()
    },
    getUserId(val) {
      this.student_user_id = val
      this.search()
    },
    details(row) {
      console.log(row, 1212)
      getXmLessonHourRecordDetail({
        xmLessonHourRecordId: row.id,
      }).then((res) => {
        console.log(res, 789456)
        this.tableData1 = []

        this.xmLesonHourRecordInfo = res.xmLesonHourRecordInfo
        this.tableData1.push(res.xmLesonHourRecordInfo)
      })
      this.dialogVisible = true
    },
    search() {
      this.page_no = 1
      this.getXmLessonHourRecord()
    },
    //获得校区员工列表
    getCampusUserList() {
      getCampusUserList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得学校用户列表')
        console.log(res)
        this.options3 = res.campusUserList
      })
    },
    getXmLessonHourRecord() {
      api_lessonHourRecordSelectLessonCost({
        eduCampusId: this.$store.state.user.selected_schools[0], // 校区Id
        stuId: this.student_user_id, // 学员ID
        classId: this.formInline.curriculum_class_id, // 班级ID
        goodsId: this.formInline.xm_goods_id, // 课程商品ID
        userId: this.formInline.lecturer_id, // 上课老师ID
        startCreateDate:
          this.formInline.creatTime2 === null
            ? ''
            : this.formInline.creatTime2[0], // 创建时间-开始
        endCreateDate:
          this.formInline.creatTime2 === null
            ? ''
            : this.formInline.creatTime2[1], // 创建时间-结束
        startSignDate:
          this.formInline.creatTime === null
            ? ''
            : this.formInline.creatTime[0], // 点名时间-开始
        endSignDate:
          this.formInline.creatTime === null
            ? ''
            : this.formInline.creatTime[1], // 点名时间 - 结束
        startClassDate:
          this.formInline.creatTime1 === null
            ? ''
            : this.formInline.creatTime1[0], // 上课时间- 开始
        endClassDate:
          this.formInline.creatTime1 === null
            ? ''
            : this.formInline.creatTime1[1], // 上课时间- 结束
        pageRequest: {
          pageNum: this.page_no,
          pageSize: this.page_size,
        },
        costTypeList: this.formInline.cost_type_arr.length > 0 ? this.formInline.cost_type_arr : null, //课消来源（1点名，2修改点名记录，3课时清零，4撤销点名记录，5补扣超上课时）
      }).then((res) => {
        if (res.totalContent) {
          this.sumData = {
            total_cost_money: res.totalContent.totalCostMoney,
            total_lesson_hour_num: res.totalContent.totalLessonHourNum,
          }
        } else {
          this.sumData = {
            total_cost_money: 0,
            total_lesson_hour_num: 0,
          }
        }
        this.tableData = res.content
        this.tableData.map((item) => {
          // item.after_lesson_hour_num = item.0
          // item.classLecturerName = item."林晓坤"
          // item.className = item.className
          // item.cost_buy_num = item.1
          // item.cost_give_num = item.0
          item.cost_money = item.costMoney
          item.cost_type = item.costType
          item.created_time = item.createdTime
          // item.curriculum_class_id = item.63287
          item.deal_user_realname = item.operator
          // item.educational_institution_id = item.36
          item.id = item.lessonHourRecordId
          // item.lecturer_id = item.6764
          item.lesson_hour_num = item.lessonHourNum
          // item.original_lesson_hour_num = item.0
          // item.stu_headImgUrl = item."https://wugecdn.steam.fun/resources/static/homepage/nanxueshengtouxiang-min.png"
          item.stu_name = item.stuName
          // item.stu_sign_date = item."2024-11-05 11:08:04"
          // item.stu_sign_state = item.1
          // item.stu_userCode = item."4dee5ce0-1b09-4132-ad43-47a318f713ba"
          // item.student_user_id = item.27626
          // item.tchPlanEndClassDate = item."2024-10-20 10:30:00"
          item.tchPlanLecturerName = item.tchName
          // item.tchPlanLessonDesc = item."小明睁开眼睛，发现自己在一个篮球场大小的小岛上，小岛上还有些不到自己腰部的植物，还有些小玩具一样的房子散落各处。这难道就是书中的小人国么？"
          item.tchPlanLessonTitle = item.courseName
          item.tchPlanSignDate = item.signDate
          item.tchPlanStartClassDate = item.classDateStr
          // item.teaching_plan_id = item.2076484
          // item.user_id = item.6764
          item.xmGoodsName = item.goodsName
          // item.xmOrderCode = item."202407100036090813537"
          // item.xm_goods_id = item.252
          // item.xm_order_goods_id = item.18031
          // item.xm_order_id = item.17061
          if (item.cost_type == 1) {
            item.cost_type1 = '点名'
          }
          if (item.cost_type == 2) {
            item.cost_type1 = '修改点名记录'
          }
          if (item.cost_type == 3) {
            item.cost_type1 = '课时清零'
          }
          if (item.cost_type == 4) {
            item.cost_type1 = '撤销点名记录'
          }
          if (item.cost_type == 5) {
            item.cost_type1 = '补扣超上课时'
          }
          if (item.lesson_hour_num < 0) {
            item.lesson_hour_numStr =
              '退还' + item.lesson_hour_num.toString().slice(1) + '课时'
          } else {
            item.lesson_hour_numStr = '消耗' + item.lesson_hour_num + '课时'
          }

          if (item.tchPlanSignDate) {
            item.tchPlanSignDate1 = item.tchPlanSignDate.slice(
              0,
              item.tchPlanSignDate.length - 3
            )
          } else {
            item.tchPlanSignDate1 = '--'
          }
          if (item.tchPlanStartClassDate) {
            item.tchPlanStartClassDate1 =
              item.tchPlanStartClassDate
          } else {
            item.tchPlanStartClassDate1 = '--'
          }
        })

        this.total = res.totalSize
      })
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getXmLessonHourRecord()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.getXmLessonHourRecord()
    },
  },
}
</script>

<style lang="scss" scoped>
.sumBg {
  width: 100%;
  background-color: #fcf1e8;
  padding: 10px 10px;
  margin-bottom: 20px;
  border-radius: 5px;
}

.mainNew {
  height: 100%;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.input-student-management {
  min-height: calc(100% - 30px);

  background-color: #fff;
  margin: 10px;
  border-radius: 5px;

  section {
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;

    .table-style {
      margin-top: 20px;
    }
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }

  .flowrecord {
    height: calc(100vh - 280px);
    margin: 20px;
    overflow-y: scroll;
  }
}
</style>

<style>
.input-student-management .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 5px;
}

.liStyle {
  width: 50%;
  float: left;
  margin-bottom: 15px;
}
</style>
